import { SvgIcon, SvgIconProps, useTheme } from "@mui/material";

const NatGatewaySvgIcon = ({
  primary,
}: SvgIconProps & { primary?: boolean }) => {
  const { palette } = useTheme();

  const color = primary ? palette.primary.main : palette.action.active;

  return (
    <SvgIcon>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_43584_4141)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.4855 10.5148L14.0135 9.88332V15.1278C15.2865 14.9518 15.4795 13.6438 15.4875 13.5843L15.4855 10.5148ZM13.5135 15.1348V9.87982L11.996 10.5163V13.6168C12.002 13.6438 12.2185 15.0003 13.5135 15.1348ZM13.6665 9.27382C13.729 9.24732 13.7995 9.24782 13.862 9.27432L15.834 10.1203C15.926 10.1598 15.9855 10.2498 15.9855 10.3498V13.6168C15.894 14.3403 15.307 15.6483 13.722 15.6483C12.1845 15.6483 11.595 14.3423 11.498 13.6513L11.496 10.3498C11.496 10.2493 11.5565 10.1583 11.649 10.1193L13.6665 9.27382ZM16.4915 9.59232L13.761 8.38932L10.996 9.55282V13.1168C10.9955 13.1378 10.969 14.5508 11.8245 15.4283C12.283 15.8988 12.9215 16.1378 13.722 16.1378C14.523 16.1378 15.1655 15.8983 15.6315 15.4268C16.499 14.5478 16.4915 13.1343 16.4915 13.1203V9.59232ZM15.99 15.7753C15.4265 16.3473 14.663 16.6378 13.722 16.6378C12.78 16.6378 12.02 16.3473 11.4635 15.7743C10.461 14.7428 10.494 13.1758 10.496 13.1098V9.38682C10.496 9.28632 10.556 9.19532 10.6485 9.15632L13.666 7.88632C13.7295 7.85982 13.8015 7.86032 13.864 7.88832L16.842 9.20082C16.933 9.24082 16.9915 9.33032 16.9915 9.42932V13.1168C16.9925 13.1793 17.005 14.7443 15.99 15.7753ZM5.496 12.1183H9.496V12.6183H5.496C4.0905 12.6183 3.0905 11.6103 3.0065 10.1103C3.0005 10.0548 3 9.98782 3 9.92082C3 8.66632 3.659 7.80932 4.9085 7.43132C4.899 7.31782 4.8925 7.19832 4.8925 7.10782C4.8925 5.64982 5.681 4.38532 6.901 3.88532C8.55 3.21132 10.422 3.43782 11.454 4.43732C11.8265 4.79932 12.116 5.20832 12.334 5.67982C12.6385 5.45432 13.034 5.34832 13.5085 5.37282C14.3985 5.41782 15.083 6.22932 15.225 7.37632C15.974 7.43832 16.4675 7.81782 16.73 8.53032L16.2615 8.70332C16.0475 8.12482 15.6575 7.86682 14.996 7.86682C14.8635 7.86682 14.754 7.76382 14.746 7.63182C14.677 6.46282 14.043 5.90032 13.483 5.87232C13.009 5.84732 12.6605 5.98182 12.4435 6.26782C12.3885 6.34032 12.3005 6.37582 12.207 6.36432C12.117 6.35032 12.041 6.28882 12.0095 6.20282C11.8075 5.65132 11.512 5.19132 11.106 4.79582C10.212 3.93082 8.561 3.74632 7.0905 4.34832C6.059 4.77082 5.3925 5.85382 5.3925 7.10782C5.3925 7.24432 5.41 7.45582 5.4255 7.58732C5.4405 7.71282 5.36 7.82932 5.2375 7.85932C4.0845 8.14532 3.5 8.83882 3.5 9.92082C3.5 9.97132 3.4995 10.0213 3.5045 10.0718C3.575 11.3193 4.356 12.1183 5.496 12.1183Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_43584_4141">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};

NatGatewaySvgIcon.muiName = "NatGatewaySvgIcon";

export default NatGatewaySvgIcon;
